import { FormControl, InputLabel, Select, SelectChangeEvent } from '@mui/material';
import React, { FC } from 'react';
import styles from './styles.module.sass';
import MenuItem from '@mui/material/MenuItem';

type Props = {
  id: string;
  title: string;
  values: string[];
  onChange: (value: SelectChangeEvent<string>) => void;
  value: string;
};

export const RefineDataItem: FC<Props> = ({ id, title, values, onChange, value }) => {
  return (
    <FormControl className={styles.filter_container}>
      <InputLabel id={id}>{title}</InputLabel>
      <Select className={styles.selector} value={value} labelId={id} label={title} name={id} onChange={onChange}>
        {values.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
